import { extendSales } from '@common/SaleUtils';
import { devSaleOverrides, devSales } from './saleData.devbase';
import { sales as baseSales } from './saleData.prod';

export const sales = extendSales(baseSales, devSales, devSaleOverrides, [
  {
    saleId: 'svsfl',
    marketingCampaign: 'devfezloveraffle',
  },
  {
    saleId: 'chasingshadows',
    marketingCampaign: 'devchasingshadows',
  },
  {
    saleId: 'foreplay',
    marketingCampaign: 'devforeplay',
  },
  {
    saleId: 'raymondlightyear',
    marketingCampaign: 'devraymondlightyear',
  },
  {
    saleId: 'emptyhorizon',
    marketingCampaign: 'devemptyhorizon',
  },
  {
    saleId: 'soundclash',
    marketingCampaign: 'devsoundclash',
  },
  {
    saleId: 'prisonrush',
    marketingCampaign: 'devprisonrush',
  },
  {
    saleId: 'barmanronan',
    marketingCampaign: 'devbarmanronan',
  },
]);

export default sales;
